export default __webpack_public_path__ + "static/media/CGM.c5e6506a.webp";